<template>
  <q-input
    dense
    ref="inputRef"
    v-model="formattedValue"
    outlined
    :disable="disable"
    :bg-color="disable ? 'brand-7' : ''"
  />
</template>

<script>
import { useCurrencyInput } from "vue-currency-input";

export default {
  name: "QCurrencyInput",
  props: {
    modelValue: Number,
    disable: Boolean,
  },
  setup() {
    const { inputRef, formattedValue } = useCurrencyInput({
      locale: "pt-BR",
      currency: "BRL",
      currencyDisplay: "symbol",
      precision: 2,
      hideCurrencySymbolOnFocus: true,
      hideGroupingSeparatorOnFocus: true,
      hideNegligibleDecimalDigitsOnFocus: false,
      autoDecimalDigits: true,
      useGrouping: true,
      accountingSign: false,
    });

    return { inputRef, formattedValue };
  },
};
</script>
